import React from 'react'
import { useEffect, useState } from 'react'
import Tabs from '../../../../../Components/Tabs'
import GetIcon from '../../../../../utils/Icon'
import { Link, useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
// import Tab3 from './Tab3'
// import Tab4 from './Tab4'
import Table from './Table'
import { usePostSalesOrderDetailsMutation, usePostFrappeClientGetMutation, usePostSalesOrderSubmitMutation } from "../../../../../store/api/salesorderapi";
import printerimg from "../../../../../assets/print.png"
import Button from '../../../../../Core/Button/Button'
import PrintModal from "../../../../../Core/Print/PrintModal";
import { useGetPaymentTermsQuery } from '../../../../../store/api/paymenttermapi'
import { useGetCurrencyListQuery, useGetSelectedCompanyQuery } from '../../../../../store/api/companyapi'
import { useGetPriceListQuery } from "../../../../../store/api/pricelistapi";
import { useGetTaxCategoryListQuery } from "../../../../../store/api/taxcategoryapi";
import { useGetTermsandConditionQuery } from "../../../../../store/api/termsandconditionapi";
import { useGetCostCenterListQuery } from "../../../../../store/api/costcenterapi";
import { useGetProjectListQuery } from "../../../../../store/api/projectapi";
import Attachment from '../../../../../utils/Attachment'


function Salesform({ salesorderId }) {
    console.log(salesorderId, "salesorderId");

    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [po_response, setpo_response] = useState("");
    const [tab, settab] = useState(1)
    const [genaralData, setgenaralData] = useState("");
    const [ItemsList, setItemsList] = useState()
    const [showDropdown, setShowDropdown] = useState(false);
    const [ptype, setptype] = useState("Error ")
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    console.log(ItemsList, "ItemsList");
    console.log(genaralData, "genaralData");
    const [getSalesOrder] = usePostFrappeClientGetMutation();
    const { data: p_term } = useGetPaymentTermsQuery();
    const { data: pricelist } = useGetPriceListQuery({ filters: JSON.stringify({ selling: 1 }) });
    const { data: currencylist } = useGetCurrencyListQuery();
    const { data: taxandchangeslist } = useGetTaxCategoryListQuery();
    const { data: tandc } = useGetTermsandConditionQuery();
    const { data: costcenterlist } = useGetCostCenterListQuery();
    const { data: projectlist } = useGetProjectListQuery();
    const [termsandcondition, settermsandcondition] = useState([]);
    const [taxandchanges, settaxandchanges] = useState('');
    const [paymentterm, setpaymentterm] = useState([]);
    const [currency, setcurrency] = useState('');
    const [pricel, setpricel] = useState('');
    const [project, setproject] = useState('');
    const [cost_center, setcost_center] = useState('');
    useEffect(() => {
			const fetchSalesOrder = async () => {
				try {
					const response = await getSalesOrder({
						doctype: "Sales Order",
						name: salesorderId,
					}).unwrap();
					if (response) {
						console.log(response, "response_new");

						setgenaralData(response.message);
						setItemsList(response.message.items);
					}
					console.log("Sales Order:", response);
				} catch (error) {
					console.error("Error fetching sales order:", error);
				}
			};

			fetchSalesOrder();
		}, [getSalesOrder, salesorderId]);


    const handleCreatePicklist = () => {
        console.log(genaralData.name, "salesorderId_go");

        nvg('/outbound/pick/createpick', {
            state: {
                order_id: genaralData.name
            }
        });
    };

    const noOfLines = ItemsList?.length || 0;

    const totalQty = ItemsList?.reduce((sum, item) => sum + (item.qty || 0), 0) || 0;
    return (
		!genaralData ? '' : <>
				<Tabs />
				<div
					className="d-flex justify-content-between p-2 "
					style={{ background: "#fcfdfe", height: "40px" }}
				>
					<div className="d-flex align-items-center customizewidth">
						<p className="m-0 breadcrumb-item">Outbound</p>
						<p className="m-0 ">
							{" "}
							<GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />{" "}
						</p>
						<p
							className="m-0 breadcrumb-item"
							style={{ cursor: "pointer" }}
							onClick={() => nvg("/outbound/outbound-sales-order")}
						>
							Sales Order List{" "}
						</p>
						<p className="m-0 ">
							{" "}
							<GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />{" "}
						</p>
						<a
							href="javascript:void(0);"
							className="pagetitle d-flex align-items-center"
							style={{
								borderBottom: "0px solid",
								textWrap: "nowrap",
								gap: "5px",
								color: "#270B79",
								fontSize: "12.2px",
							}}
						>
							Sales Order View
							<button
								className={`rounded-pill ${
									genaralData?.status === "Draft"
										? "newdesign2343"
										: "newdesign123"
								}`}
							>
								{genaralData?.status || "New"}
							</button>
						</a>
					</div>
					<div
						className="d-flex align-items-center justify-content-end customizewidth"
						style={{ gap: "5px", flexGrow: "1" }}
					>
						{(genaralData?.intozi_status === "Partially Picked" ||
							genaralData?.intozi_status === "Pick List Created") && (
							<div style={{ position: "relative", display: "inline-block" }}>
								<div className="bustom-btn-00989">
									<div
										onClick={handleCreatePicklist}
										className="custom-btn-blue852 createbtn d-flex"
										style={{ gap: "2px", height: "28px" }}
									>
										<GetIcon iconName={"FaPlus"} size={12} />
										Pick List
									</div>
								</div>
							</div>
						)}
					</div>
				</div>

				<div
					className=""
					style={{
						width: "100%",
						overflow: "hidden",
						backgroundColor: "#fff",
						flexGrow: "1",
					}}
				>
					<div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
						<div className="d-flex justify-content-between align-items-end ">
							<ul
								className="nav nav-tabs mb-0"
								style={{ color: "white", border: "none" }}
							>
								<li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
									<a
										className={
											tab == 1
												? "nav-link active-tab-custom text-white border-radius-top-corner"
												: "nav-link nav-link-tab-custom bg-white border-radius-top-corner"
										}
										onClick={() => {
											settab(1);
										}}
										href="javascript:void(0);"
									>
										General Details
										{tab == 1 ? (
											<GetIcon iconName="MdKeyboardArrowDown" size={15} />
										) : (
											<GetIcon iconName="MdKeyboardArrowRight" size={15} />
										)}
									</a>
								</li>
								<li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
									<a
										className={
											tab == 2
												? "nav-link active-tab-custom text-white border-radius-top-corner"
												: "nav-link nav-link-tab-custom bg-white border-radius-top-corner"
										}
										onClick={() => {
											settab(2);
										}}
										href="javascript:void(0);"
									>
										Address & Contact{" "}
										{tab == 2 ? (
											<GetIcon iconName="MdKeyboardArrowDown" size={15} />
										) : (
											<GetIcon iconName="MdKeyboardArrowRight" size={15} />
										)}
									</a>
								</li>
							</ul>
							<Attachment doctype="Sales Order" docname={salesorderId} />
						</div>
					</div>
					<div
						className="row d-flex justify-content-between"
						style={{ marginTop: "14px" }}
					>
						<div
							className="col-3 sidebarbox"
							style={{
								visibility: tab == 1 ? "visible" : "hidden",
								height: tab == 1 ? "auto" : "0px",
							}}
						>
							<Tab1
								genaralData={genaralData}
								pTerms={{
									paymentterm: paymentterm,
									setpaymentterm: setpaymentterm,
									list: p_term?.data,
								}}
								price={{
									list: pricelist?.data,
									setvalue: setpricel,
									value: pricel,
								}}
								currency={{
									list: currencylist?.data,
									setvalue: setcurrency,
									value: currency,
								}}
								taxandchanges={{
									list: taxandchangeslist?.data,
									setvalue: settaxandchanges,
									value: taxandchanges,
								}}
								termandcondition={{
									termsandcondition,
									settermsandcondition,
									list: tandc?.data,
								}}
								cost_center={{
									list: costcenterlist?.data,
									setvalue: setcost_center,
									value: cost_center,
								}}
								project={{
									list: projectlist?.data,
									setvalue: setproject,
									value: project,
								}}

								// setTab1Data={setTab1Data} setTab1CustomerData={setTab1CustomerData} orderNo={orderNo} fieldErrors={fieldErrors} activityboll={activityboll}
							/>
						</div>

						<div
							className="col-9 d-flex flex-column mt-2"
							style={{
								visibility: tab == 1 ? "visible" : "hidden",
								height: tab == 1 ? "auto" : "0px",
								minHeight: tab == 1 ? "440px" : "0",
							}}
						>
							<div className="d-flex" style={{ gap: "5px" }}>
								<div className="d-flex pb-2" style={{ gap: "5px" }}>
									<p className="NoOfLine">
										No. of lines -{" "}
										<span style={{ color: "#2563EB" }}> {noOfLines}</span>
									</p>
									<p className="TotalQty">
										Total Quantity -{" "}
										<span style={{ color: "#16A34A" }}> {totalQty}</span>
									</p>
								</div>
							</div>
							<div className="tableLabel">
								<div
									style={{
										width: "98.5%",
										borderBottom: "1px solid #caced3",
										marginBottom: "6px",
									}}
								></div>
								<p
									style={{
										color: "#1E1E1E",
										fontWeight: "500",
										fontSize: "15px",
										marginBottom: "4px",
									}}
								>
									Item Details
								</p>
							</div>
							<Table
								allitems={ItemsList}
								// setselected_item_data={setselected_item_data} list_data={getitem_list_data} po_status={po_response}
							/>
       
							   <div className=" mt-auto  pb-2" >
                                <div className="row ">
                                    <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        <div style={{ width: '20%' }}>
                                            <p className="TotalQtywithoutBg">
                                                Ordered Quantity -
                                                <span style={{ color: '#EC642A' }}>
                                                    {genaralData?.items.reduce((sum, item) => sum + Number(item.qty), 0)}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '18%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Total Value -
                                                <span style={{ color: '#FF5969' }}>
                                                    {genaralData?.items.reduce((sum, item) => sum + Number(item.qty * item.rate), 0)}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '24%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Tax Type -
                                                <span style={{ color: '#C40AB8' }}>
													{console.log("check geraraldata is here",genaralData)}
                                                    {genaralData?.taxes?.length == 0 ? '' : genaralData?.taxes?.reduce((acc, curr) => {
                                                                                        if (!acc.includes(curr.description)) {
                                                                                            acc.push(curr.description);
                                                                                        }
                                                                                        return acc;
                                                                                        }, []).join(', ')}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '15%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Tax -
                                                <span style={{ color: '#2563EB' }}>
                                                     {genaralData?.total_taxes_and_charges}

                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '22%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Grand Total -
                                                <span style={{ color: '#16A34A' }}>
                                                    {genaralData?.grand_total}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

							{/* <div className=" mt-4 pb-2" style={{ display: po_response.data ? '' : 'none' }}>
                            <div className="row">
                                <div className="col-3">
                                    <p className="TotalQtywithoutBg">Ordered Quantity -  <span className="px-2" style={{ color: '#EC642A' }}> 12</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Taxable Value - <span className="px-2" style={{ color: '#FF5969' }}> 25</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Tax - <span className="px-2" style={{ color: '#2563EB' }}>256</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Total Value - <span className="px-2" style={{ color: '#16A34A' }}> 155</span></p>
                                </div>
                            </div>
                        </div> */}
						</div>
						<div
							className="col-12"
							style={{
								visibility: tab == 2 ? "visible" : "hidden",
								height: tab == 2 ? "auto" : "0px",
							}}
						>
							<Tab2 genaralData={genaralData} />
						</div>
						{/* <div className="col-12" style={{ visibility: tab == 3 ? "visible" : 'hidden', height: tab == 3 ? "auto" : '0px'   }}> <Tab3 /> </div>
                    <div className="col-12" style={{ visibility: tab == 4 ? "visible" : 'hidden', height: tab == 4 ? "auto" : '0px'  }}> <Tab4 /> </div> */}
					</div>
					{showPrintModal && (
						<PrintModal
							onClose={() => setShowPrintModal(false)}
							documentId={salesorderId}
							doctype="Sales Order"
							title="Print Sales Order"
						/>
					)}
				</div>

				{/* <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      /> */}
			</>
		);
}

export default Salesform
